import React from 'react'
import SliderShowtimes from '../SliderShowtimes'


const CustomShowtimesSelection = ({
    movies,
    currentActiveSelection,
    setIdForActiveSelection,
    theme,
    showMovieTimesSortedAfterTheatres, 
    selectionId, 
    itemSelection, 
    programOverviewShowtimesType,
    translation
}) => {
    if(!itemSelection) {
        return ''
    }

    const { title, filterType, filterValue }  = itemSelection
    const items = Object.keys(movies)

    return items.length !== 0 && <SliderShowtimes
        showMovieTimesSortedAfterTheatres={showMovieTimesSortedAfterTheatres}
        theme={theme}
        title={title}
        items={items}
        filterValue={filterValue}
        filterType={filterType}
        programOverviewShowtimesType={programOverviewShowtimesType}
        currentActiveSelection={currentActiveSelection}
        setIdForActiveSelection={setIdForActiveSelection}
        selectionId={selectionId}
        moviesData={movies}
        translation={translation}
        isFront={true}
        scrollToPosition={'slider-showtimes slider-selection-showtimes ' + selectionId}
    />
}

export default CustomShowtimesSelection